module.exports = __webpack_public_path__ + "img/1367234288.b57acea1.jpg";